<template>
  <div
    class="flex flex-col text-center justify-center items-center"
    :class="{
      'mt-3': !showMakeAnotherPaymentButton && !showPortalLoginLink,
      'my-3': showMakeAnotherPaymentButton || showPortalLoginLink,
    }"
  >
    <div class="text-primary-600 font-bold text-4xl mb-2">Payment received</div>
    <div class="text-gray-800 text-xl font-bold">
      {{ formatCurrency(paymentAmount) }} has been applied to your invoice
      <span
        v-if="selectedPaymentMethod === 'CARD' && invoice.cc_fees_rate"
        class="text-gray-400 text-sm font-bold"
      >
        <br />
        A {{ invoice.cc_fees_rate }}% processing fee has been included in the charge.
      </span>
    </div>
    <div class="mt-6 text-gray-400 font-bold text-xs">We sent you and your merchant a confirmation email</div>
    <div
      class="flex justify-center items-center mt-6"
      v-if="!showLoader"
    >
      <button
        type="button"
        v-if="showMakeAnotherPaymentButton"
        class="mt-3 mr-3 flex items-center border border-primary-600 bg-primary-600 font-medium !rounded text-sm px-5 py-2.5 focus:outline-none text-white hover:border-primary-600 hover:bg-primary-600"
        @click="$emit('make-another-payment')"
      >
        Make another payment
      </button>
      <a
        :href="portalLoginLink"
        v-if="showPortalLoginLink"
        class="mt-3 flex items-center focus:ring-4 border border-gray-400 font-medium rounded text-sm px-5 py-2.5 focus:outline-none text-gray-600 focus:ring-primary-300"
      >
        Access your portal
      </a>
    </div>
    <div
      class="flex justify-center items-center mt-6"
      v-if="showLoader"
    >
      <client-loading-indicator
        :styled="false"
        class="fill-white text-primary-700"
      />
    </div>
  </div>
</template>
<script>
import currencyUtils from "../../../js/helpers/currencyUtils"
import ClientLoadingIndicator from "../../client_auth/components/client-loading-indicator.vue"

export default {
  name: "PortalCollectPaymentSuccess",
  components: {
    ClientLoadingIndicator,
  },
  props: {
    invoice: { type: Object, default: () => ({}) },
    paymentAmount: { type: Number, required: true },
    invoiceUpdated: { type: Boolean, required: true },
    showLoader: { type: Boolean, default: false },
    selectedPaymentMethod: { type: String, default: "" },
  },
  emits: ["make-another-payment"],
  computed: {
    showPortalLoginLink() {
      return window.FinancialCents.company.hasOwnProperty("firm_custom_uri")
    },

    portalLoginLink() {
      const customUri = window.FinancialCents.company.firm_custom_uri
      return customUri
        ? `${window.location.origin}/cp/${window.FinancialCents.company.firm_custom_uri}`
        : `${window.location.origin}/cp`
    },

    showMakeAnotherPaymentButton() {
      if (!this.invoice.allow_partial_payments) {
        return false
      }
      return this.invoice.allow_partial_payments && this.invoice.outstanding_amount > 0 && this.invoiceUpdated
    },
  },

  methods: {
    formatCurrency(amount) {
      return currencyUtils.formatCurrency(amount, this.invoice.currency)
    },
  },
}
</script>
